import { requests } from "./Requests";
import axios from "axios";

export const ImportsApi = {
  getUploadUrl: (fileName: string) => {
    return requests.get<string>(`/Imports/getUploadUrl?filename=${fileName}`);
  },
  uploadFile: async (url: string, file: File) => {
    if (!(url.length > 0) || !file) return;

    return await axios.put(url, file, {
      headers: {
        "Content-Type": "application/x-msaccess"
      }
    })
  },
  addImportJob: (dataId: string) => {
    return requests.post<boolean>(`/Imports/addImportJob`, { dataId: dataId })
  },
  getUploadId: () => {
    return requests.get<number>(`/Imports/getUploadId`);
  }
};
